var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.854,
    height: 21.315,
    viewBox: "0 0 24.854 21.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.36,40.755a1.777,1.777,0,0,0-.308-.023H5.518l.382-.178a3.556,3.556,0,0,0,1-.711l4.917-4.917a1.84,1.84,0,0,0,.258-2.356,1.778,1.778,0,0,0-2.667-.231L.521,41.23a1.778,1.778,0,0,0,0,2.515h0l8.892,8.891a1.778,1.778,0,0,0,2.667-.178,1.84,1.84,0,0,0-.258-2.356L6.914,45.178a3.557,3.557,0,0,0-.889-.649l-.533-.24H22.955a1.841,1.841,0,0,0,1.876-1.494A1.778,1.778,0,0,0,23.36,40.755Z",
    transform: "translate(0 -31.842)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0c172c713c0a54aef1fd005d57375e40.svg";
export { ForwardRef as ReactComponent };